import { useMutation, useQueryClient } from 'react-query';
import { axios, createFormData } from '../api/axios';

export default function useAddDirectMessage(options) {
  const queryClient = useQueryClient();

  const query = useMutation((data) => {
    return axios.post('/direct/new_message/', createFormData(data));
  }, options || {});

  const updateQueryData = (response, memberId) => {
    memberId = parseInt(memberId, 10);

    const { status, direct_message } = response;

    if (status === 'ok') {
      const queryKey = ['direct/get-messages', memberId];

      queryClient.invalidateQueries(queryKey);

      /*
            const queryData = queryClient.getQueryData(queryKey);

            const list = queryData.data.list.reverse();

            list.push(direct_message);

            queryData.data.list = list.reverse();

            queryClient.setQueryData(queryKey, queryData);
             */
    }
  };

  const mutate = (data, options) => {
    if (options) {
      query.mutate(data, {
        onSuccess: (response, variables, context) => {
          updateQueryData(response.data, data.memberId);

          if (typeof options.onSuccess === 'function') {
            options.onSuccess(response, variables, context);
          }
        },
        onError: (err, variables, context) => {
          if (typeof options.onError === 'function') {
            options.onError(err, variables, context);
          }
        },
      });
    } else {
      query.mutate(data, {
        onSuccess: (response) => {
          updateQueryData(response.data, data.memberId);
        },
      });
    }
  };

  return [mutate, query];
}
